import RpcClass from "../../../../../server/RpcClass.js";

import yaml from "js-yaml"

import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.model.plm.Product';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class Product extends RpcClass{

    /**
     *  @class Product
     *  @alias module:src/server/com/silkplm/model/plm/Product.Product
     *  
     * */
    constructor(){
        super();

        /** @type {BigDecimal}  */
        this.CBM = null;
        /** @type {module:src/server/com/silkplm/model/plm/EAN.EAN[]}  */
        this.EANList = null;
        /** @type {string}  */
        this.EANWarning = null;
        /** @type {string}  */
        this.EID = null;
        /** @type {string}  */
        this.GPC = null;
        /** @type {string}  */
        this.HSCode = null;
        /** @type {string}  */
        this.PM = null;
        /** @type {string}  */
        this.VATRate = null;
        /** @type {boolean}  */
        this.__archived = null;
        /** @type {number}  */
        this.__familyId = null;
        /** @type {boolean}  */
        this.__hidden = null;
        /** @type {number}  */
        this.__parent = null;
        /** @type {Date}  */
        this.__versionDate = null;
        /** @type {Object.<string, *>}  */
        this._translations = null;
        /** @type {string}  */
        this.additionalInformationForBranding = null;
        /** @type {boolean}  */
        this.aiInsightInProgress = null;
        /** @type {boolean}  */
        this.allValueAttributesAreFilled = null;
        /** @type {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}  */
        this.attachments = null;
        /** @type {string}  */
        this.brand = null;
        /** @type {string}  */
        this.capacity = null;
        /** @type {string}  */
        this.category = null;
        /** @type {boolean}  */
        this.constructed = null;
        /** @type {string}  */
        this.currentSelectedRegion = null;
        /** @type {LocalDate}  */
        this.dateOfLastGS1Integration = null;
        /** @type {string}  */
        this.description = null;
        /** @type {string}  */
        this.detailsName = null;
        /** @type {BigDecimal}  */
        this.duty = null;
        /** @type {string}  */
        this.englishFullName = null;
        /** @type {string}  */
        this.englishName = null;
        /** @type {string}  */
        this.externalIDs = null;
        /** @type {module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery}  */
        this.gallery = null;
        /** @type {string}  */
        this.id = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
        this.initialPrice = null;
        /** @type {boolean}  */
        this.integrationExternalSystem = null;
        /** @type {boolean}  */
        this.integrationWithGS1 = null;
        /** @type {string}  */
        this.lastSixDigitsEAN = null;
        /** @type {string}  */
        this.marketingName = null;
        /** @type {module:src/server/com/silkplm/model/plm/ApplicationUserOnProductEmbedded.ApplicationUserOnProductEmbedded[]}  */
        this.merchants = null;
        /** @type {string}  */
        this.name = null;
        /** @type {string}  */
        this.notes = null;
        /** @type {number}  */
        this.numberOfProduct = null;
        /** @type {module:src/server/com/silkplm/model/plm/ValueAttribute.ValueAttribute[]}  */
        this.productCategoryAttributes = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
        this.promotionalPriceInitial = null;
        /** @type {number}  */
        this.quantityInner = null;
        /** @type {number}  */
        this.quantityOuter = null;
        /** @type {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}  */
        this.recordMetadata = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
        this.retailPriceInitial = null;
        /** @type {string}  */
        this.sampleStatus = null;
        /** @type {string}  */
        this.stateOfGS1Integration = null;
        /** @type {BigDecimal}  */
        this.stockLevels = null;
        /** @type {string}  */
        this.supplierId = null;
        /** @type {string}  */
        this.supplierProductId = null;
        /** @type {string}  */
        this.unit = null;
        /** @type {number}  */
        this.version = null;

        if(window["SessionManager"]?.isLoggedIn()){
            const formConfig = window['FormsLoader']?.detectFormConfig(FULL_CLASS);
            for(const f of formConfig.fields){
                if(f.formDisabled){
                    continue;
                }
                if( f.defaultValue !== null) {
                    this[f.fieldName] = yaml.load(f.defaultValue);
                }
             }
        }
    }



    /**
     * Get extension tab: Product Attributes
     * @returns {Promise<ProductAttributes>}
     */

    async getProductAttributes(){
        return Rpc.Forms.getEntityExtension(
            FULL_CLASS,
            this.id,
            "productId",
            "com.silkplm.model.plm.ProductAttributes");
   }
    /**
     * Get extension tab: Logistics Data
     * @returns {Promise<LogisticsData>}
     */

    async getLogisticsData(){
        return Rpc.Forms.getEntityExtension(
            FULL_CLASS,
            this.id,
            "productId",
            "com.silkplm.model.plm.LogisticsData");
   }

    /**
     * Get list of detail Required Test Product
     * @returns {Promise<RequiredTestProduct[]>}
     */

    async listRequiredTestProduct(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.RequiredTestProduct",
        "productId");
    }
    /**
     * Get list of detail Product In Season
     * @returns {Promise<ProductInSeason[]>}
     */

    async listProductInSeason(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.ProductInSeason",
        "productId");
    }
    /**
     * Get list of detail Application User On Product
     * @returns {Promise<ApplicationUserOnProduct[]>}
     */

    async listApplicationUserOnProduct(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.ApplicationUserOnProduct",
        "productId");
    }

    /** @type {string}  */
    get supplierIdSupplierCode(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['supplierIdSupplierCode'] : null, this.__metadata__['supplierIdSupplierCode']?.remoteType);
    }
    set supplierIdSupplierCode(val){
    }
    // fk: false

    /** @type {string}  */
    get categorySymbol(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['categorySymbol'] : null, this.__metadata__['categorySymbol']?.remoteType);
    }
    set categorySymbol(val){
    }


    /** @type {string}  */
    get computedExternalIDs(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['computedExternalIDs'] : null, this.__metadata__['computedExternalIDs']?.remoteType);
    }
    set computedExternalIDs(val){
    }


    /** @type {string}  */
    get dynamicAttributesComputedMap(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['dynamicAttributesComputedMap'] : null, this.__metadata__['dynamicAttributesComputedMap']?.remoteType);
    }
    set dynamicAttributesComputedMap(val){
    }


    /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
    get finalPriceFromTheLastOrder(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['finalPriceFromTheLastOrder'] : null, this.__metadata__['finalPriceFromTheLastOrder']?.remoteType);
    }
    set finalPriceFromTheLastOrder(val){
    }


    /** @type {string}  */
    get fullName(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['fullName'] : null, this.__metadata__['fullName']?.remoteType);
    }
    set fullName(val){
    }


    /** @type {string}  */
    get materialComposition(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['materialComposition'] : null, this.__metadata__['materialComposition']?.remoteType);
    }
    set materialComposition(val){
    }


    /** @type {string}  */
    get merchantsComputed(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['merchantsComputed'] : null, this.__metadata__['merchantsComputed']?.remoteType);
    }
    set merchantsComputed(val){
    }


    /** @type {number}  */
    get originCountry(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['originCountry'] : null, this.__metadata__['originCountry']?.remoteType);
    }
    set originCountry(val){
    }

    /** @returns {Promise<String>} */
    getOriginCountryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Country', 'originCountry', allowRemote); //  true 
    }

    /** @returns {String} */
    getOriginCountryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Country', 'originCountry'); //  true 
    }

    /** @returns {Promise<Country>} */
    getOriginCountryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Country', 'originCountry',  allowRemote); //  true 
    }

    /** @type {number}  */
    get port(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['port'] : null, this.__metadata__['port']?.remoteType);
    }
    set port(val){
    }

    /** @returns {Promise<String>} */
    getPortLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Port', 'port', allowRemote); //  true 
    }

    /** @returns {String} */
    getPortStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Port', 'port'); //  true 
    }

    /** @returns {Promise<Port>} */
    getPortEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Port', 'port',  allowRemote); //  true 
    }

    /** @type {string}  */
    get productAttributesText(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productAttributesText'] : null, this.__metadata__['productAttributesText']?.remoteType);
    }
    set productAttributesText(val){
    }


    /** @type {boolean}  */
    get productInSeasons(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productInSeasons'] : null, this.__metadata__['productInSeasons']?.remoteType);
    }
    set productInSeasons(val){
    }


    /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
    get promotionalPriceFromTheLastOrder(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['promotionalPriceFromTheLastOrder'] : null, this.__metadata__['promotionalPriceFromTheLastOrder']?.remoteType);
    }
    set promotionalPriceFromTheLastOrder(val){
    }


    /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
    get retailPriceFromTheLastOrder(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['retailPriceFromTheLastOrder'] : null, this.__metadata__['retailPriceFromTheLastOrder']?.remoteType);
    }
    set retailPriceFromTheLastOrder(val){
    }


    /** @type {string}  */
    get seasons(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['seasons'] : null, this.__metadata__['seasons']?.remoteType);
    }
    set seasons(val){
    }


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withCBM(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.CBM = v;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/plm/EAN.EAN[]}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withEANList(val){
        this.EANList = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withEANWarning(val){
        this.EANWarning = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withEID(val){
        this.EID = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withGPC(val){
        this.GPC = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withHSCode(val){
        this.HSCode = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withPM(val){
        this.PM = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getPMLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.users.ApplicationUser', 'PM', allowRemote); //  true 
    }

    /** @returns {String} */
        getPMStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.users.ApplicationUser', 'PM'); //  true 
    }

        /** @returns {Promise<ApplicationUser>} */
    getPMEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.users.ApplicationUser', 'PM', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withVATRate(val){
        this.VATRate = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getVATRateLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.VatLevel', 'VATRate', allowRemote); //  true 
    }

    /** @returns {String} */
        getVATRateStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.VatLevel', 'VATRate'); //  true 
    }

        /** @returns {Promise<VatLevel>} */
    getVATRateEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.VatLevel', 'VATRate', allowRemote); //  true 
    }

    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    with__archived(val){
        this.__archived = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    with__familyId(val){
        this.__familyId = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    with__hidden(val){
        this.__hidden = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    with__parent(val){
        this.__parent = val;
        return this;
    };


    /**
     * @param val {Date}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    with__versionDate(val){
        let rawValue = val;
        let v = val;
        v = new Date(rawValue)
        this.__versionDate = v;
        return this;
    };


    /**
     * @param val {Object.<string, *>}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    with_translations(val){
        this._translations = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withAdditionalInformationForBranding(val){
        this.additionalInformationForBranding = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withAiInsightInProgress(val){
        this.aiInsightInProgress = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withAllValueAttributesAreFilled(val){
        this.allValueAttributesAreFilled = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withAttachments(val){
        this.attachments = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withBrand(val){
        this.brand = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getBrandLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Brand', 'brand', allowRemote); //  true 
    }

    /** @returns {String} */
        getBrandStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Brand', 'brand'); //  true 
    }

        /** @returns {Promise<Brand>} */
    getBrandEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Brand', 'brand', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withCapacity(val){
        this.capacity = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withCategory(val){
        this.category = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCategoryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Category', 'category', allowRemote); //  true 
    }

    /** @returns {String} */
        getCategoryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Category', 'category'); //  true 
    }

        /** @returns {Promise<Category>} */
    getCategoryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Category', 'category', allowRemote); //  true 
    }

    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withConstructed(val){
        this.constructed = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withCurrentSelectedRegion(val){
        this.currentSelectedRegion = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withDateOfLastGS1Integration(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.dateOfLastGS1Integration = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withDescription(val){
        this.description = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withDetailsName(val){
        this.detailsName = val;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withDuty(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.duty = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withEnglishFullName(val){
        this.englishFullName = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withEnglishName(val){
        this.englishName = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withExternalIDs(val){
        this.externalIDs = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withGallery(val){
        this.gallery = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withId(val){
        this.id = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withInitialPrice(val){
        this.initialPrice = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withIntegrationExternalSystem(val){
        this.integrationExternalSystem = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withIntegrationWithGS1(val){
        this.integrationWithGS1 = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withLastSixDigitsEAN(val){
        this.lastSixDigitsEAN = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withMarketingName(val){
        this.marketingName = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/plm/ApplicationUserOnProductEmbedded.ApplicationUserOnProductEmbedded[]}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withMerchants(val){
        this.merchants = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withName(val){
        this.name = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withNotes(val){
        this.notes = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withNumberOfProduct(val){
        this.numberOfProduct = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/plm/ValueAttribute.ValueAttribute[]}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withProductCategoryAttributes(val){
        this.productCategoryAttributes = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withPromotionalPriceInitial(val){
        this.promotionalPriceInitial = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withQuantityInner(val){
        this.quantityInner = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withQuantityOuter(val){
        this.quantityOuter = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withRecordMetadata(val){
        this.recordMetadata = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withRetailPriceInitial(val){
        this.retailPriceInitial = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withSampleStatus(val){
        this.sampleStatus = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSampleStatusLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.SampleStatus', 'sampleStatus', allowRemote); //  true 
    }

    /** @returns {String} */
        getSampleStatusStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.SampleStatus', 'sampleStatus'); //  true 
    }

        /** @returns {Promise<SampleStatus>} */
    getSampleStatusEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.SampleStatus', 'sampleStatus', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withStateOfGS1Integration(val){
        this.stateOfGS1Integration = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getStateOfGS1IntegrationLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.IntegrationStatuses', 'stateOfGS1Integration', allowRemote); //  true 
    }

    /** @returns {String} */
        getStateOfGS1IntegrationStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.IntegrationStatuses', 'stateOfGS1Integration'); //  true 
    }

        /** @returns {Promise<IntegrationStatuses>} */
    getStateOfGS1IntegrationEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.IntegrationStatuses', 'stateOfGS1Integration', allowRemote); //  true 
    }

    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withStockLevels(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.stockLevels = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withSupplierId(val){
        this.supplierId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSupplierIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Suppliers', 'supplierId', allowRemote); //  true 
    }

    /** @returns {String} */
        getSupplierIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Suppliers', 'supplierId'); //  true 
    }

        /** @returns {Promise<Suppliers>} */
    getSupplierIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Suppliers', 'supplierId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withSupplierProductId(val){
        this.supplierProductId = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withUnit(val){
        this.unit = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getUnitLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Unit', 'unit', allowRemote); //  true 
    }

    /** @returns {String} */
        getUnitStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Unit', 'unit'); //  true 
    }

        /** @returns {Promise<Unit>} */
    getUnitEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Unit', 'unit', allowRemote); //  true 
    }

    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/Product.Product}
     */
    withVersion(val){
        this.version = val;
        return this;
    };




    /**
    * @param {string[]?} fields
    * @returns {Promise<Product>}
    */
    async save(fields){
        return this.__save(FULL_CLASS, fields);
    }

    async load(id=null){
        if(id == null){
            id = this.id;
        }
        let newVersion = await loadProduct(id);
        for(const k in newVersion){
            this[k] = newVersion[k];
        }
    }
    /**
     * @return {Promise}
     */
    async delete(){
        return Rpc.Forms.deleteEntity(FULL_CLASS, this.id);
    }
    /**
     * @param {*|string} replacementIdOrInst
     * @return {Promise}
     */
    async deleteWithReplacement(replacementIdOrInst){
        if(replacementIdOrInst.hasOwnProperty('id')){
            replacementIdOrInst = replacementIdOrInst.id;
        }
        return Rpc.Forms.deleteEntityWithReplacement(FULL_CLASS, this.id, replacementIdOrInst);
    }
    /**
     * CAN_DELETE | SUGGEST_REPLACEMENT | FORCE_REPLACEMENT | DELETE_RESTRICTED | DELETE_NOT_PERMITTED
     * @return {Promise<String>>}
     */
    async canDelete(){
        return Rpc.Forms.canDeleteEntity(FULL_CLASS, this.id);
    }

    /**
     * @param fieldName
     * @returns {Promise<FieldValidationResult>}
     */
    async validateField(fieldName){
        return Rpc.Forms.validateField(FULL_CLASS, fieldName, this[fieldName], this.id);
    }

    /**
     * @returns {Promise<InputValidationResult>}
     */
    async checkConstraints(){
        return Rpc.Forms.checkConstraints(FULL_CLASS, this);
    }
    /** @returns {Promise<String>}*/
    async getFkFieldLabel(fiendName, allowRemote=false) {
        if(fiendName === 'PM'){
            return this.getPMLabel(allowRemote);
        }
        if(fiendName === 'VATRate'){
            return this.getVATRateLabel(allowRemote);
        }
        if(fiendName === 'brand'){
            return this.getBrandLabel(allowRemote);
        }
        if(fiendName === 'category'){
            return this.getCategoryLabel(allowRemote);
        }
        if(fiendName === 'sampleStatus'){
            return this.getSampleStatusLabel(allowRemote);
        }
        if(fiendName === 'stateOfGS1Integration'){
            return this.getStateOfGS1IntegrationLabel(allowRemote);
        }
        if(fiendName === 'supplierId'){
            return this.getSupplierIdLabel(allowRemote);
        }
        if(fiendName === 'unit'){
            return this.getUnitLabel(allowRemote);
        }
        if(fiendName === 'originCountry'){
            return this.getOriginCountryLabel(allowRemote);
        }
        if(fiendName === 'port'){
            return this.getPortLabel(allowRemote);
        }

        return '';
    }

    /** @returns {Promise<*>}*/
    async getFkFieldEntity(fiendName, allowRemote=false) {
        if(fiendName === 'PM'){
            return this.getPMEntity(allowRemote);
        }
        if(fiendName === 'VATRate'){
            return this.getVATRateEntity(allowRemote);
        }
        if(fiendName === 'brand'){
            return this.getBrandEntity(allowRemote);
        }
        if(fiendName === 'category'){
            return this.getCategoryEntity(allowRemote);
        }
        if(fiendName === 'sampleStatus'){
            return this.getSampleStatusEntity(allowRemote);
        }
        if(fiendName === 'stateOfGS1Integration'){
            return this.getStateOfGS1IntegrationEntity(allowRemote);
        }
        if(fiendName === 'supplierId'){
            return this.getSupplierIdEntity(allowRemote);
        }
        if(fiendName === 'unit'){
            return this.getUnitEntity(allowRemote);
        }
        return null;
    }


    /**
     * @param {string} externalSystemName
     * @returns {Promise<string>}
     */
    async externalId(externalSystemName){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, this.id, externalSystemName);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async loadByExternalId(externalSystemName, externalId){
    //clazzName, silkId, extSystem
        let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
        if(res.recordStatus !== "EXISTS"){
            throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
        }
        await this.load(res.silkId);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async bindExternalId(externalSystemName, externalId){
      //clazzName, extId, extSystem, silkId
      return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, this.id);
   }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async removeExternalId(externalSystemName, externalId){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, this.id);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @returns {Promise<string>}
     */
    async readBoundValue(externalSystemName, keyName){
      let res = await Rpc.Integrations.readObjectData(FULL_CLASS, this.id, externalSystemName, keyName);
      return JSON.parse(res);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @param {Object} val
     * @returns {Promise<>}
     */
    async bindValue(externalSystemName, keyName, val){
      return Rpc.Integrations.storeObjectData(FULL_CLASS, externalSystemName, this.id, keyName, val);
    }

    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}

/**
 * @param {string} id
 * @param {boolean?} loadFkObjects
 * @returns {Promise<Product>}
 */
async function loadProduct(id, loadFkObjects){
    if(loadFkObjects){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<Product[]>}
 */
async function listProduct(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @param {string} id
 * @returns {Promise<string>}
 */
async function labelProduct(id){
    return Rpc.Forms.getEntityLabel(FULL_CLASS, id);
}
// STATICS --------------------------------------

/**
 * @param {string} id
 * @param {boolean?} loadDetails
 * @returns {Promise<Product>}
 */
Product.load = async function(id, loadDetails=false){
    if(loadDetails){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<Product[]>}
 */
Product.list = async function(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @returns {Promise<Product[]>}
 */
Product.listExtended = async function(){
    return Rpc.Forms.listExtendedEntities(FULL_CLASS);
}

/**
 * @returns {Promise<Product[]>}
 */
Product.getRemoteClass = function(){
    return FULL_CLASS;
}

/**
 * @param {string} externalSystem
 * @param {string} extId
 * @param {boolean?} loadDetails
 * @returns {Promise<Product>}
 */
Product.loadByExternalId = async function(externalSystem, extId, loadDetails=false){

    let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, extId, externalSystem);
    if(res.recordStatus !== "EXISTS"){
        throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
    }
    return Product.load(res.silkId, loadDetails);
}


// INTEGRATIONS --------------------------------

/**
 * @param {string} externalSystemName
 * @param {string} silkId
 * @returns {Promise<IdMapping>}
 */
Product.bindingFromSilkId = async function(externalSystemName, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, silkId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<IdMapping>}
 */
Product.bindingFromExternalId = async function(externalSystemName, externalId){
    //clazzName, silkId, extSystem
    return  Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @param {string} silkId
 * @returns {Promise<>}
 */
Product.bindExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, extId, extSystem, silkId
    return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<>}
 */
Product.removeExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {IdMapping} binding
 * @returns {Promise<>}
 */
Product.removeExternalBinding = async function(binding){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, binding.externalId, binding.externalSystem, binding.silkId);
}



let metadata = {};
metadata['CBM'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['EANList'] = {'remoteType' : 'module:src/server/com/silkplm/model/plm/EAN.EAN[]', 'jsType' : 'module:src/server/com/silkplm/model/plm/EAN.EAN[]', 'mapped' : 'false'};
metadata['EANWarning'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['EID'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['GPC'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['HSCode'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['PM'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['VATRate'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['__archived'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__familyId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__hidden'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__parent'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__versionDate'] = {'remoteType' : 'java.time.Instant', 'jsType' : 'Date', 'mapped' : 'true'};
metadata['_translations'] = {'remoteType' : 'Object.<string, *>', 'jsType' : 'Object.<string, *>', 'mapped' : 'false'};
metadata['additionalInformationForBranding'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['aiInsightInProgress'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['allValueAttributesAreFilled'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['attachments'] = {'remoteType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'jsType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'mapped' : 'false'};
metadata['brand'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['capacity'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['category'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['constructed'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['currentSelectedRegion'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['dateOfLastGS1Integration'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['description'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['detailsName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['duty'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['englishFullName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['englishName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['externalIDs'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['gallery'] = {'remoteType' : 'module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery', 'jsType' : 'module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery', 'mapped' : 'false'};
metadata['id'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['initialPrice'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['integrationExternalSystem'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['integrationWithGS1'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['lastSixDigitsEAN'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['marketingName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['merchants'] = {'remoteType' : 'module:src/server/com/silkplm/model/plm/ApplicationUserOnProductEmbedded.ApplicationUserOnProductEmbedded[]', 'jsType' : 'module:src/server/com/silkplm/model/plm/ApplicationUserOnProductEmbedded.ApplicationUserOnProductEmbedded[]', 'mapped' : 'false'};
metadata['name'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['notes'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['numberOfProduct'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['productCategoryAttributes'] = {'remoteType' : 'module:src/server/com/silkplm/model/plm/ValueAttribute.ValueAttribute[]', 'jsType' : 'module:src/server/com/silkplm/model/plm/ValueAttribute.ValueAttribute[]', 'mapped' : 'false'};
metadata['promotionalPriceInitial'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['quantityInner'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['quantityOuter'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['recordMetadata'] = {'remoteType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'jsType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'mapped' : 'false'};
metadata['retailPriceInitial'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['sampleStatus'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['stateOfGS1Integration'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['stockLevels'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['supplierId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierProductId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['unit'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['version'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['categorySymbol'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['computedExternalIDs'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['dynamicAttributesComputedMap'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['finalPriceFromTheLastOrder'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['fullName'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['materialComposition'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['merchantsComputed'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['originCountry'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['port'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['productAttributesText'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productInSeasons'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['promotionalPriceFromTheLastOrder'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['retailPriceFromTheLastOrder'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['seasons'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierIdSupplierCode'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.model.plm.Product';
metadata.__type_short__ = 'Product';
Product.prototype.__metadata__ = metadata;

Product.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/model/plm/Product */
export default Product

export { Product , loadProduct, listProduct, labelProduct }
